import React from 'react';
import { MediaPreview } from '../hooks/useSupportMedia';
import theme from '@shared/utils/themeColors';

interface SupportMediaPreviewProps {
  media: MediaPreview;
  onRemove: () => void;
}

const SupportMediaPreview: React.FC<SupportMediaPreviewProps> = ({
  media,
  onRemove,
}) => {
  const progress = media.progress || 0;
  const isComplete = progress === 100;
  const isGif = media.type === 'gif';

  return (
    <div className="relative w-full">
      <div className="flex items-center">
        <div className="flex-shrink-0 mr-3">
          {media.type === 'image' || media.type === 'gif' ? (
            <div className="relative w-14 h-14 rounded-md overflow-hidden">
              <img
                src={media.url}
                alt="Media preview"
                className="w-full h-full object-cover"
              />
            </div>
          ) : media.type === 'video' ? (
            <div className="relative w-14 h-14 rounded-md overflow-hidden bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
              <svg
                className={`w-8 h-8 ${theme.text.inactive}`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm12.553 1.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
              </svg>
            </div>
          ) : (
            <div className="relative w-14 h-14 rounded-md overflow-hidden bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
              <svg
                className={`w-8 h-8 ${theme.text.inactive}`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          )}
        </div>

        <div className="flex-grow">
          <div className="flex justify-between">
            <p className={`text-sm font-medium ${theme.text.secondary}`}>
              {media.type.charAt(0).toUpperCase() + media.type.slice(1)} ready to send
            </p>
            <button
              type="button"
              onClick={onRemove}
              className={`text-sm ${theme.text.error} hover:text-red-600 ml-2 focus:outline-none`}
            >
              Remove
            </button>
          </div>

          {!isGif && !isComplete && (
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 mt-1">
              <div
                className={`${theme.bg.brand} h-1.5 rounded-full`}
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          )}
        </div>
      </div>

      {media.error && (
        <div className={`mt-1 text-sm ${theme.text.error}`}>{media.error}</div>
      )}
    </div>
  );
};

export default SupportMediaPreview;
